<wsd-extended-card
  [title]="'DATA_PORTAL.FEDERATION.TITLE' | translate">
  <div class="p-grid p-nogutter">
    <div *ngFor="let federation of federations" class="p-col-4 p-md-6 p-lg-4">
      <div class="p-grid p-nogutter p-align-center m-b-5">
        <div class="p-col shrink m-r-5">
          <img [width]="18"
               [src]="getImage(federation?.image?.content)"
               [alt]="federation.image?.name">
        </div>
        <div class="p-col p-r-10">
          <a [routerLink]="['/data', federation.id]">
            {{ federation.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</wsd-extended-card>
